module.exports = "<buses-page></buses-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFleet/buses.html
// module id = 1323
// module chunks = 0